// extracted by mini-css-extract-plugin
var _1 = "Legal_buttonLinkContainer__y7hvb";
var _2 = "Legal_legalContainer__3Ikh7";
var _3 = "Legal_seeDetails__a+qiH";
var _4 = "Legal_supContainer__m+WhH";
export { _1 as "buttonLinkContainer", _2 as "legalContainer", _3 as "seeDetails", _4 as "supContainer" }
